import { Footer as FooterComponent } from '@comicrelief/component-library';

import footerItems from './footerItems.json';
import footerCopy from './footerCopy.json';

// Continuing to use hardcoded footer items for now as MVP, Footer Service integration to follow,
// see: https://github.com/comicrelief/serverless-content/blob/master/src/Action/Footer.action.js

function Footer() {
  return (
    <FooterComponent
      navItems={footerItems}
      footerCopy={footerCopy}
      campaign="Comic Relief"
      overrideallowList
      showFundraisingRegulatorLogo
    />
  );
}

export default Footer;
